import { useState } from 'react';
import { DialogUI } from '../Interface';
import { ItemPage } from './ItemPage';

const ItemDialog = ({
  showDialog,
  onClose,
  selectedItemCode = null,
  hideRightPanel = false,
  selectOnClose = true,
  initialAddMode = false,
}) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleClose = () => {
    if (onClose) {
      // ha nincs kiválasztott cikk, null-lal hívjuk vissza
      onClose(selectOnClose ? selectedItem ?? null : null);
    }
    // lokális állapot reset a következő nyitáshoz
    setSelectedItem(null);
  };

  return (
    <DialogUI
      open={showDialog}
      headerContent={'Cikkek'}
      fullWidth={true}
      onClose={handleClose}
      closeBtn={true}
      maxWidth="xl"
    >
      {showDialog && (
        <ItemPage
          fromDialog={true}
          dialogSetSelectedItem={setSelectedItem}
          selectedItemCode={selectedItemCode}
          hideRightPanel={hideRightPanel}
          initialAddMode={initialAddMode}
        />
      )}
    </DialogUI>
  );
};

export default ItemDialog;
